import styled from "styled-components";

import colors from "../../assets/css/colors";

export const TitlePage = styled.h2`
  font-size: 1rem;
  font-weight: bold;
  color: ${colors.tertiary};
`;